import { call, put, select } from 'redux-saga/effects';

import { goToSiteService, goToFactoryService } from './router';
import {
  createSiteRequest,
  deleteSiteRequest,
  fetchSiteRequest,
  updateSiteRequest,
} from '../requests';
import { siteByIdSelector, nextSitePositionSelector, pathSelector } from '../../../selectors';
import { createSite, deleteSite, updateSite } from '../../../actions';
import { createLocalId } from '../../../utils/local-id';

export function* createSiteService(factoryId, data) {
  const nextData = {
    ...data,
    position: yield select(nextSitePositionSelector, factoryId),
  };

  const localId = yield call(createLocalId);

  yield put(
    createSite({
      ...nextData,
      factoryId,
      id: localId,
    }),
  );

  const {
    success,
    payload: { site },
  } = yield call(createSiteRequest, factoryId, localId, nextData);

  if (success) {
    yield call(goToSiteService, site.id);
  }
}

export function* createSiteInCurrentFactoryService(data) {
  const { factoryId } = yield select(pathSelector);

  yield call(createSiteService, factoryId, data);
}

export function* fetchSite(id) {
  yield call(fetchSiteRequest, id);
}

export function* updateSiteService(id, data) {
  yield put(updateSite(id, data));
  yield call(updateSiteRequest, id, data);
}

export function* moveSiteService(id, index) {
  const { factoryId } = yield select(siteByIdSelector, id);
  const position = yield select(nextSitePositionSelector, factoryId, index, id);

  yield call(updateSiteService, id, {
    position,
  });
}

export function* deleteSiteService(id) {
  const { siteId, factoryId } = yield select(pathSelector);

  if (id === siteId) {
    yield call(goToFactoryService, factoryId);
  }

  yield put(deleteSite(id));
  yield call(deleteSiteRequest, id);
}
